import React from 'react'

export default function StepThird() {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M53.5703 6.42871H27.856C25.4891 6.42871 23.5703 8.34751 23.5703 10.7144V27.8573C23.5703 30.2242 25.4891 32.143 27.856 32.143H53.5703C55.9373 32.143 57.856 30.2242 57.856 27.8573V10.7144C57.856 8.34751 55.9373 6.42871 53.5703 6.42871Z" stroke="url(#paint0_linear_6243_6302)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M47.1431 42.8574H17.1431C16.0065 42.8574 14.9164 42.4058 14.1127 41.6021C13.309 40.7984 12.8574 39.7083 12.8574 38.5716V17.1431" stroke="url(#paint1_linear_6243_6302)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M38.5711 53.5715H6.42829C5.29164 53.5715 4.20156 53.1198 3.39783 52.3162C2.59411 51.5126 2.14258 50.4224 2.14258 49.2858V25.7144" stroke="url(#paint2_linear_6243_6302)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_6243_6302" x1="40.7132" y1="6.42871" x2="40.7132" y2="32.143" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint1_linear_6243_6302" x1="30.0003" y1="17.1431" x2="30.0003" y2="42.8574" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
        <linearGradient id="paint2_linear_6243_6302" x1="20.3569" y1="25.7144" x2="20.3569" y2="53.5715" gradientUnits="userSpaceOnUse">
          <stop stopColor="#80A235" />
          <stop offset="1" stopColor="#2F6B73" />
        </linearGradient>
      </defs>
    </svg>
  )
}
